export default function isAndroid() {
  return /android/.test(navigator.userAgent.toLowerCase());
}
